export default __webpack_public_path__ + "static/media/47_you_doh.cfc207c2.png";